export default __webpack_public_path__ + "static/media/sqaure-draft-icon.be983bef.svg";